import { useEffect, useState, useCallback } from "react"

import styled, { css } from "styled-components"
import { fdesktop, fmobile, fresponsive, ftablet } from "utils/fullyResponsive"

interface Props {
  className?: string
  sources: string[]
}

export default function HeroVideo({ className = "", sources }: Props) {
  const [videoRef, setVideoRef] = useState<HTMLVideoElement | null>(null)
  const [vidSrc, setVidSrc] = useState<JSX.Element[] | null>(null)

  const loadVideo = useCallback(async () => {
    const allVidSources = sources.map(async vid => {
      const el = await import(`../../static/homepage/homeHero3Dnew.mp4`)

      return el.default
    })

    const srcset = await Promise.all(
      allVidSources.map(async (vid, i, arr) => {
        const res = await vid
        return (
          <source
            key={res}
            src={res}
            type={arr.length > 1 && i === 0 ? "video/webm" : "video/mp4"}
          />
        )
      })
    )

    setVidSrc(srcset)
  }, [sources])

  useEffect(() => {
    if (videoRef) {
      loadVideo()
    }
  }, [loadVideo, videoRef])

  return (
    <div style={{width: "1440px"}}>
    <Vid
      className={className}
      ref={ref => setVideoRef(ref)}
      autoPlay
      loop
      playsInline
      preload="none"
      muted
    >
      {vidSrc}
    </Vid>
    </div>
  )
}

const Vid = styled.video`

  position: absolute;
  object-fit: fill; 
  
    ${fresponsive(css`
      right: 29%; 
      width: 20%;
      height: calc(100% - 550px);
  `)}
   ${fdesktop(css`
      right: 18%;
      width: 35%;
      height: calc(100% - 500px);
  `)}
  ${ftablet(css`
    right: 14%;
    width: 40%;
    height: 100%;
`)}
${fmobile(css`
  right: 14%;
    width: 40%;
    height: 100%;
`)}

`
